// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d3f2cf74","687":"ae8a16fc","959":"4d80a377"}[chunkId] + ".chunk.js";
};